import { createSelector } from 'utils/app.util';

export const getWellControlCategoriesFromState = createSelector(
  (state) => state.getIn(['entity', 'wellControl', 'categories']),
  (categories) => categories,
);
